import { jsxs, jsx } from 'react/jsx-runtime';
import './InputNumber-7d93e963.js';
import { Link } from './components/shared/Link.es.js';
import { __rest } from 'tslib';
import 'rc-select';
import '@teko-builder/icons';
import './FormItem-098fa619.js';
import { getStyle } from './utils.es.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import './Col-475038db.js';
import './Slider-93041044.js';
import './Container-ca9f82d8.js';
import './Divider-600cb92e.js';
import { R as Ripple } from './Ripple-abf0f8a0.js';
import './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';
import styled from '@emotion/styled';
import { Position } from '@teko-builder/types/pb';
import { MAPPING_ALIGNMENT_FLEX } from './constants.es.js';
import { g as getIconCompoment } from './common-dbaafe9f.js';
import React from 'react';

const ButtonV1 = (props) => {
    const { commonStyle, align, text, iconConfig, link, enabled = false, onClick, className, disabled, event, } = props;
    const IconComponent = getIconCompoment(iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.icon);
    const hasPrefix = (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.show) &&
        (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.position) === Position.front &&
        !!IconComponent;
    const hasSuffix = (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.show) &&
        (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.position) === Position.behind &&
        !!IconComponent;
    const renderButton = (enable) => {
        const btn = (jsxs(StyledButton$1, Object.assign({ disabled: disabled, commonStyle: commonStyle, onClick: !(link === null || link === void 0 ? void 0 : link.href)
                ? (e) => {
                    e.preventDefault();
                    if (typeof onClick === 'function' && !disabled) {
                        onClick();
                    }
                }
                : undefined }, { children: [hasPrefix && IconComponent, jsx("span", Object.assign({ style: Object.assign(Object.assign({}, (hasPrefix &&
                        !!text && {
                        marginLeft: iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.spacing,
                    })), (!!hasSuffix &&
                        !!text && {
                        marginRight: iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.spacing,
                    })) }, { children: text })), hasSuffix && IconComponent, !disabled && jsx(Ripple, {})] })));
        return (jsx(ButtonWrapper$1, Object.assign({ align: align, className: className }, { children: enable ? (btn) : (jsx(Link, Object.assign({}, link, event, { children: btn }))) })));
    };
    return renderButton(enabled);
};
const StyledButton$1 = styled.button(({ commonStyle }) => `
  position: relative;
  border: none;
  padding: 0;
  align-items: center;
  text-decoration: none;
  display: flex;
  cursor: pointer;
  justify-content: center;
  background: transparent;
  font-size: 14px;
  line-height: 16px;
  ${getStyle(commonStyle)}
  > span {
    font-size: inherit;
    line-height: inherit;
  }
  &[disabled] {
    color: #00000040;
    border-color: #d9d9d9;
    background: #f5f5f5;
    text-shadow: none;
    box-shadow: none;
    cursor: not-allowed;
  }
`);
const ButtonWrapper$1 = styled.div(({ align }) => `
  display: flex;
  justify-content: ${MAPPING_ALIGNMENT_FLEX[align]};
  width: 100%;
`);
ButtonV1.displayName = 'Button';

const ButtonV2 = React.forwardRef((props, ref) => {
    const { commonStyle, text, iconConfig, link, isEditingMode = false, onClick, className, disabled, buttonStyle, customText, event } = props, rest = __rest(props, ["commonStyle", "text", "iconConfig", "link", "isEditingMode", "onClick", "className", "disabled", "buttonStyle", "customText", "event"]);
    const IconComponent = getIconCompoment(iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.icon);
    const hasPrefix = (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.show) && (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.position) === 'left' && !!IconComponent;
    const hasSuffix = (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.show) && (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.position) === 'right' && !!IconComponent;
    const trackingEventName = event === null || event === void 0 ? void 0 : event.trackingEventName;
    const btn = (jsxs(StyledButton, Object.assign({ ref: ref, disabled: disabled, buttonStyle: buttonStyle, onClick: (e) => {
            if (typeof window !== 'undefined' &&
                trackingEventName &&
                !isEditingMode &&
                !disabled) {
                window.gtag &&
                    window.gtag('event', trackingEventName);
                window.fbq &&
                    window.fbq('trackCustom', trackingEventName);
                window.track &&
                    window.track('customEvent', trackingEventName);
            }
            if (typeof onClick === 'function' && !disabled && !isEditingMode) {
                e.preventDefault();
                onClick();
            }
        } }, rest, { children: [hasPrefix && IconComponent, jsx("span", Object.assign({ style: Object.assign(Object.assign({}, (hasPrefix &&
                    !!text && {
                    marginLeft: iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.spacing,
                })), (!!hasSuffix &&
                    !!text && {
                    marginRight: iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.spacing,
                })) }, { children: customText ? (customText) : (jsx("span", { dangerouslySetInnerHTML: { __html: text } })) })), hasSuffix && IconComponent, !disabled && !customText && jsx(Ripple, {})] })));
    if (isEditingMode) {
        return btn;
    }
    return (jsx(ButtonWrapper, Object.assign({ commonStyle: commonStyle, className: className }, { children: jsx(Link, Object.assign({}, link, event, { children: btn })) })));
});
const StyledButton = styled.button(({ buttonStyle }) => `
    position: relative;
    border: none;
    align-items: center;
    text-decoration: none;
    display: flex;
    cursor: pointer;
    justify-content: center;
    font-size: 14px;
    line-height: 16px;
    background: transparent;
    > span {
      font-size: inherit;
      line-height: inherit;
    }
    &[disabled] {
      color: #00000040;
      border-color: #d9d9d9;
      background: #f5f5f5;
      text-shadow: none;
      box-shadow: none;
      cursor: not-allowed;
    }
    ${getStyle(buttonStyle)}
`);
const ButtonWrapper = styled.div(({ commonStyle }) => `
  display: flex;
  width: 100%;
  ${getStyle(commonStyle)}
`);
ButtonV2.displayName = 'ButtonV2';

export { ButtonV1 as B, ButtonV2 as a, ButtonWrapper as b };
